/**
 * Bookmark — Merkliste (Abschnitt 3 der Anforderungen): Drucksachen und
 * Sitzungen bookmarken, mit eigener Notiz versehen. Immer user-gebunden
 * (Backend filtert auf auth.uid).
 * Konvention: {Entity}, Add{Entity}, Update{Entity}.
 */
export var BookmarkTargetType;
(function (BookmarkTargetType) {
    BookmarkTargetType["PAPER"] = "paper";
    BookmarkTargetType["MEETING"] = "meeting";
})(BookmarkTargetType || (BookmarkTargetType = {}));
export const BOOKMARK_OBJECT = "bookmark";
//# sourceMappingURL=bookmark-model.js.map